<template>
  <div>
    <el-backtop />
    <Header />
    <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/FrontHeader'
import Footer from '@/components/FrontFooter'
export default {
  data () {
    return {
      isShow: false
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    submit () {
      this.isShow = true
    },

    onSuccess (msg) {
      this.isShow = false // 通过验证后，需要手动关闭模态框
    },

    onClose () {
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
